export {
  REDUCED_MOTION_MEDIA_QUERY,
  reducedMotionStyles,
  withReducedMotion,
} from './reducedMotion';
